// @ts-nocheck
(function () {
  if (window.location.pathname !== '/pages/about-us') return;

  const PHOTO_1 = 'https://cdn.shopify.com/s/files/1/0717/3832/7110/files/IMG_1917.png?v=1773853364';
  const PHOTO_2 = 'https://cdn.shopify.com/s/files/1/0717/3832/7110/files/IMG_1834.jpg?v=1773854603';
  const SHOP_URL = '/collections/all';

  const PRODUCTS = [
    {
      name: 'Active B-Complex',
      img: 'https://www.drfelsnaturals.com/cdn/shop/files/IMG-1832.png?v=1782464240&width=400',
      url: '/collections/all',
    },
    {
      name: 'CoQ10',
      img: 'https://www.drfelsnaturals.com/cdn/shop/files/IMG-0559.png?v=1775077888&width=400',
      url: '/collections/all',
    },
    {
      name: 'Cortisol Balance',
      img: 'https://www.drfelsnaturals.com/cdn/shop/files/IMG-1833.png?v=1782464197&width=400',
      url: '/collections/all',
    },
    {
      name: 'Kids Supplement',
      img: 'https://www.drfelsnaturals.com/cdn/shop/files/IMG-0227.png?v=1779449947&width=400',
      url: '/collections/all',
    },
  ];

  const css = `
    .ab-wrap * { box-sizing: border-box; margin: 0; padding: 0; }
    .ab-wrap a { text-decoration: none; }
    .ab-wrap img { display: block; max-width: 100%; }

    /* ── HERO ── */
    .ab-hero {
      background: #faf7f2;
      padding: 80px 24px 72px;
      text-align: center;
      border-bottom: 1px solid #ede8e0;
    }
    .ab-hero__inner { max-width: 680px; margin: 0 auto; }
    .ab-pill {
      display: inline-block;
      background: #fff;
      border: 1.5px solid #e0dbd3;
      border-radius: 100px;
      padding: 5px 18px;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #888;
      margin-bottom: 22px;
    }
    .ab-hero__title {
      font-size: clamp(2rem, 5vw, 3.1rem);
      font-weight: 800;
      line-height: 1.15;
      color: #1a1a1a;
      margin-bottom: 18px;
      font-family: var(--font-primary--family, serif);
    }
    .ab-hero__sub {
      font-size: 1.05rem;
      color: #666;
      line-height: 1.75;
      max-width: 560px;
      margin: 0 auto;
    }

    /* ── DR. FELIX ── */
    .ab-doctor {
      background: #fff;
      padding: 80px 24px;
    }
    .ab-doctor__inner {
      max-width: 1080px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: 1fr 1.55fr;
      gap: 64px;
      align-items: start;
    }

    /* Left: photo stack */
    .ab-photos {
      position: sticky;
      top: 24px;
    }
    .ab-photos__stack {
      position: relative;
      margin-bottom: 24px;
    }
    .ab-photos__main {
      width: 100%;
      aspect-ratio: 4/5;
      object-fit: cover;
      border-radius: 20px;
      border: 1.5px solid #e0d8cc;
      display: block;
    }
    .ab-photos__accent {
      position: absolute;
      bottom: -20px;
      right: -20px;
      width: 44%;
      aspect-ratio: 1/1;
      object-fit: cover;
      border-radius: 14px;
      border: 3px solid #fff;
      box-shadow: 0 8px 28px rgba(0,0,0,0.14);
    }
    .ab-creds__name {
      font-size: 1.15rem;
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 4px;
      font-family: var(--font-primary--family, serif);
    }
    .ab-creds__role {
      font-size: 0.8rem;
      color: #888;
      margin-bottom: 20px;
      line-height: 1.5;
    }
    .ab-badges {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
    .ab-badge {
      background: #faf7f2;
      border: 1.5px solid #e0dbd3;
      border-radius: 8px;
      padding: 5px 12px;
      font-size: 0.72rem;
      font-weight: 700;
      color: #555;
      white-space: nowrap;
    }

    /* Right: bio */
    .ab-bio__eyebrow {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.13em;
      text-transform: uppercase;
      color: #aaa;
      display: block;
      margin-bottom: 12px;
    }
    .ab-bio__title {
      font-size: clamp(1.6rem, 3vw, 2.2rem);
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 28px;
      font-family: var(--font-primary--family, serif);
      line-height: 1.2;
    }
    .ab-bio__body {
      font-size: 0.95rem;
      color: #555;
      line-height: 1.85;
      display: flex;
      flex-direction: column;
      gap: 18px;
    }
    .ab-bio__body p { margin: 0; }
    .ab-bio__highlight {
      background: #faf7f2;
      border-left: 3px solid #1a1a1a;
      border-radius: 0 12px 12px 0;
      padding: 16px 20px;
      font-size: 0.9rem;
      color: #444;
      line-height: 1.7;
      margin-top: 4px;
    }

    /* ── STATS ── */
    .ab-stats {
      background: #1a1a1a;
      padding: 56px 24px;
    }
    .ab-stats__inner {
      max-width: 1080px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;
      text-align: center;
    }
    .ab-stat__num {
      font-size: 2.2rem;
      font-weight: 900;
      color: #faf7f2;
      line-height: 1;
      margin-bottom: 8px;
      font-family: var(--font-primary--family, serif);
    }
    .ab-stat__label {
      font-size: 0.78rem;
      color: #777;
      line-height: 1.5;
      font-weight: 500;
    }

    /* ── PRODUCTS ── */
    .ab-products {
      background: #faf7f2;
      padding: 80px 24px;
    }
    .ab-products__inner {
      max-width: 1080px;
      margin: 0 auto;
      text-align: center;
    }
    .ab-products__eyebrow {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.13em;
      text-transform: uppercase;
      color: #aaa;
      display: block;
      margin-bottom: 12px;
    }
    .ab-products__title {
      font-size: clamp(1.5rem, 3vw, 2rem);
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 48px;
      font-family: var(--font-primary--family, serif);
    }
    .ab-products__grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
    }
    .ab-prod-card {
      background: #fff;
      border-radius: 18px;
      overflow: hidden;
      border: 1.5px solid #ede8e0;
      transition: transform 0.2s, box-shadow 0.2s;
    }
    .ab-prod-card:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 32px rgba(0,0,0,0.09);
    }
    .ab-prod-card__img {
      width: 100%;
      aspect-ratio: 1/1;
      object-fit: cover;
      background: #f5f0e8;
    }
    .ab-prod-card__name {
      font-size: 0.82rem;
      font-weight: 700;
      color: #1a1a1a;
      padding: 14px 16px;
      text-align: left;
    }
    .ab-products__cta {
      margin-top: 40px;
    }
    .ab-btn {
      display: inline-block;
      padding: 15px 36px;
      background: #1a1a1a;
      color: #faf7f2;
      font-size: 0.92rem;
      font-weight: 800;
      border-radius: 100px;
      letter-spacing: 0.02em;
      transition: background 0.2s, transform 0.15s;
    }
    .ab-btn:hover { background: #000; transform: translateY(-2px); }

    /* ── PROMISE ── */
    .ab-promise {
      background: #fff;
      padding: 88px 24px;
      text-align: center;
      border-top: 1px solid #ede8e0;
      border-bottom: 1px solid #ede8e0;
    }
    .ab-promise__inner { max-width: 700px; margin: 0 auto; }
    .ab-promise__icon {
      font-size: 2.4rem;
      margin-bottom: 20px;
      display: block;
    }
    .ab-promise__quote {
      font-size: clamp(1.15rem, 2.5vw, 1.4rem);
      font-style: italic;
      line-height: 1.75;
      color: #333;
      font-family: var(--font-primary--family, serif);
      margin-bottom: 24px;
    }
    .ab-promise__body {
      font-size: 0.92rem;
      color: #777;
      line-height: 1.75;
      margin-bottom: 36px;
    }

    /* ── VALUES ── */
    .ab-values {
      background: #faf7f2;
      padding: 80px 24px;
    }
    .ab-values__inner { max-width: 1080px; margin: 0 auto; text-align: center; }
    .ab-values__eyebrow {
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.13em;
      text-transform: uppercase;
      color: #aaa;
      display: block;
      margin-bottom: 12px;
    }
    .ab-values__title {
      font-size: clamp(1.5rem, 3vw, 2rem);
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 48px;
      font-family: var(--font-primary--family, serif);
    }
    .ab-values__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      text-align: left;
    }
    .ab-value-card {
      background: #fff;
      border-radius: 18px;
      padding: 28px 24px;
      border: 1.5px solid #ede8e0;
    }
    .ab-value-card__icon {
      font-size: 1.6rem;
      margin-bottom: 14px;
      display: block;
    }
    .ab-value-card__title {
      font-size: 0.95rem;
      font-weight: 800;
      color: #1a1a1a;
      margin-bottom: 8px;
    }
    .ab-value-card__desc {
      font-size: 0.82rem;
      color: #777;
      line-height: 1.65;
    }

    /* ── MOBILE ── */
    @media (max-width: 768px) {
      .ab-hero { padding: 60px 20px 56px; }
      .ab-doctor { padding: 56px 20px; }
      .ab-doctor__inner { grid-template-columns: 1fr; gap: 32px; }
      .ab-photos { position: static; }
      .ab-photos__stack { max-width: 320px; margin: 0 auto 24px; }
      .ab-photos__accent { right: -12px; bottom: -12px; }
      .ab-stats { padding: 48px 20px; }
      .ab-stats__inner { grid-template-columns: repeat(2, 1fr); gap: 32px; }
      .ab-products { padding: 56px 20px; }
      .ab-products__grid { grid-template-columns: repeat(2, 1fr); }
      .ab-promise { padding: 64px 20px; }
      .ab-values { padding: 56px 20px; }
      .ab-values__grid { grid-template-columns: 1fr; gap: 14px; }
    }
    @media (max-width: 480px) {
      .ab-stats__inner { grid-template-columns: repeat(2, 1fr); }
    }
  `;

  const productCards = PRODUCTS.map(p => `
    <a href="${p.url}" class="ab-prod-card">
      <img src="${p.img}" alt="${p.name}" class="ab-prod-card__img" loading="lazy">
      <p class="ab-prod-card__name">${p.name}</p>
    </a>
  `).join('');

  const html = `
    <div class="ab-wrap">

      <!-- HERO -->
      <div class="ab-hero">
        <div class="ab-hero__inner">
          <span class="ab-pill">Our Story</span>
          <h1 class="ab-hero__title">Wellness Rooted in<br>Rigorous Science</h1>
          <p class="ab-hero__sub">Welcome to Dr. Fel's Naturals — a company founded on the principle that true wellness should be rooted in rigorous science, expert knowledge, and the power of nature.</p>
        </div>
      </div>

      <!-- DR. FELIX -->
      <div class="ab-doctor">
        <div class="ab-doctor__inner">
          <div class="ab-photos">
            <div class="ab-photos__stack">
              <img src="${PHOTO_1}" alt="Dr. Felix Effah" class="ab-photos__main">
              <img src="${PHOTO_2}" alt="Dr. Felix Effah" class="ab-photos__accent">
            </div>
            <p class="ab-creds__name">Dr. Felix Effah</p>
            <p class="ab-creds__role">Pharmacologist &amp; Toxicologist<br>Founder, Dr. Fel's Naturals</p>
            <div class="ab-badges">
              <span class="ab-badge">Ph.D — British Govt Sponsored</span>
              <span class="ab-badge">St. George's, Univ. of London</span>
              <span class="ab-badge">Cambridge University</span>
              <span class="ab-badge">New York University</span>
              <span class="ab-badge">Imperial College London</span>
              <span class="ab-badge">FDA Toxicologist</span>
              <span class="ab-badge">UK Health Security Agency</span>
              <span class="ab-badge">Univ. of Rochester Medical Center</span>
            </div>
          </div>
          <div class="ab-bio">
            <span class="ab-bio__eyebrow">Who is Dr. Felix Effah?</span>
            <h2 class="ab-bio__title">The Science Behind<br>Every Supplement</h2>
            <div class="ab-bio__body">
              <p>Dr. Felix Effah is a distinguished Pharmacologist and Toxicologist with a robust academic foundation from St. George's University of London Medical School. He has spent time at Cambridge University and New York University, and holds a Ph.D sponsored by the British Government and Imperial College London.</p>
              <p>He has conducted extensive research at premier institutions, including the University of Rochester Medical Center and the UK Health Security Agency. Dr. Effah specializes in inhalation toxicology and public health, dedicated to understanding the complex interactions between chemicals and the human body to improve safety standards and health outcomes. He has also worked for the FDA in the USA as a Toxicologist.</p>
              <div class="ab-bio__highlight">
                His expertise centers on scrutinizing the safety and biological effects of various substances using sophisticated models — including 3D lung models and advanced biochemical analysis. This rigorous background forms the bedrock of the quality and safety of every product.
              </div>
              <p>Dr. Effah applies this critical, research-driven mindset to the full supplement line. His commitment bridges complex science and effective, trustworthy public health solutions — with every product prioritizing third-party testing and clean formulations backed by biological science.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- STATS -->
      <div class="ab-stats">
        <div class="ab-stats__inner">
          <div class="ab-stat">
            <p class="ab-stat__num">Ph.D</p>
            <p class="ab-stat__label">British Government<br>Sponsored Research</p>
          </div>
          <div class="ab-stat">
            <p class="ab-stat__num">3+</p>
            <p class="ab-stat__label">World-Class<br>Institutions</p>
          </div>
          <div class="ab-stat">
            <p class="ab-stat__num">100%</p>
            <p class="ab-stat__label">Third-Party<br>Tested Products</p>
          </div>
        </div>
      </div>

      <!-- PRODUCTS -->
      <div class="ab-products">
        <div class="ab-products__inner">
          <span class="ab-products__eyebrow">What we make</span>
          <h2 class="ab-products__title">Our Product Line</h2>
          <div class="ab-products__grid">
            ${productCards}
          </div>
          <div class="ab-products__cta">
            <a href="${SHOP_URL}" class="ab-btn">Shop All Products &rarr;</a>
          </div>
        </div>
      </div>

      <!-- OUR PROMISE -->
      <div class="ab-promise">
        <div class="ab-promise__inner">
          <span class="ab-promise__icon">🤝</span>
          <p class="ab-promise__quote">"When you choose Dr. Fel's Naturals, you are choosing a brand built on expertise, transparency, and a genuine passion for health advocacy."</p>
          <p class="ab-promise__body">Our products are designed to empower you to live a life of resilience and optimal health — guided by a scientist who understands the mechanisms of the human body at the deepest level.</p>
          <a href="${SHOP_URL}" class="ab-btn">Start Your Wellness Journey &rarr;</a>
        </div>
      </div>

      <!-- VALUES -->
      <div class="ab-values">
        <div class="ab-values__inner">
          <span class="ab-values__eyebrow">What drives us</span>
          <h2 class="ab-values__title">Our Core Commitments</h2>
          <div class="ab-values__grid">
            <div class="ab-value-card">
              <span class="ab-value-card__icon">🔬</span>
              <p class="ab-value-card__title">Rigorous Science</p>
              <p class="ab-value-card__desc">Every formulation is built on peer-reviewed research and clinical expertise — not trends or marketing claims.</p>
            </div>
            <div class="ab-value-card">
              <span class="ab-value-card__icon">🧾</span>
              <p class="ab-value-card__title">Full Transparency</p>
              <p class="ab-value-card__desc">We openly share our ingredients, sourcing, and third-party test results. No hidden additives, no proprietary blends.</p>
            </div>
            <div class="ab-value-card">
              <span class="ab-value-card__icon">🌿</span>
              <p class="ab-value-card__title">Nature + Science</p>
              <p class="ab-value-card__desc">We believe the best supplements combine the power of nature with the precision of modern science — and never compromise on either.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  `;

  function inject() {
    const target =
      document.querySelector('.main-page') ||
      document.querySelector('[data-section-type="main-page"]') ||
      document.querySelector('main .shopify-section') ||
      document.querySelector('main');
    if (!target) return;

    const style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
    target.innerHTML = html;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
